import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ShareDataService {
  private messageSource = new BehaviorSubject("sharedata start");
  currentMessage = this.messageSource.asObservable();
  constructor() {
  }
  
  changeMessage(message: string) {
    this.messageSource.next(message)
  }


}
